export const PRIVACY_NOTICE = '/DSRAPI';
export const ACCESS_TOKEN = '/v1/generate-access-token';
export const IBS_REQUEST = '/comprehensive/privacy/notice/v1.0/integration';

/**
 * Visit request end points start
 */
export const PRIVACY_JIRA = '/SOEPrivacyJIRA';

export const SEND_OTP = (requestId: string) =>
  `${PRIVACY_JIRA}/visitor/otp/send?requestId=${requestId}`;

export const VERIFY_OTP = () => `${PRIVACY_JIRA}/visitor/otp/verify`;

export const FORM_LOOKUPS = () => `${PRIVACY_JIRA}/visitor/lookups/identity`;

export const VERIFY_REQUEST_STATUS = (requestId: string) =>
  `${PRIVACY_JIRA}/visitor/request/status?requestId=${requestId}`;

export const SUBMIT_VISIT_REQUEST = () => `${PRIVACY_JIRA}/visitor/submit`;

export const IBS_LOOKUPS = () => `${IBS_REQUEST}/ibs/lookup`;

export const IBS_REQUEST_SUBMIT = () => `${IBS_REQUEST}/ibs-request/submit`;

export const GET_GOOGLE_ADDRESS_FROM_LAT_LNG = () =>
  `https://maps.googleapis.com/maps/api/geocode/json`;
/**
 * Visit request end points ends
 */

/**
 * FOI request end points start
 */
export const SUBMIT_FOI_REQUEST = () => `${IBS_REQUEST}/freedom-request/submit`;

/**
 * Survey end points start
 */
export const SURVEY_LOOKUPS = (data: string) => `/survey/lookup/${data}`;
export const SURVEY_SUBMIT = (data: string) => `/survey/submit/${data}`;
